import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {Tag} from "primereact/tag";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import {formatCrmDateTime, translateCrmLeadStatus} from '../crmFormatters';
import {useHistory, useParams} from "react-router-dom";

const LeadListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {action, id, entity} = useParams();
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [scope, setScope] = useState('ACTIVE');
  const [conversion, setConversion] = useState(null);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = '';
      if(lazyParams.filters && lazyParams.filters.partnerName && lazyParams.filters.partnerName.value) {
        query += '?search[partner_name]=' + lazyParams.filters.partnerName.value;
      } else {
        query = window.App.transformQueryParams(lazyParams)
      }
      query += (query.includes('?') ? '&' : '?') + 'include_closed=' + (scope === 'ALL' ? '1' : '0');
      axios.get(process.env.REACT_APP_API_HOST + "/api/v2/crm-lead" + query,
        {
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setLeads(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    const canConvert = rowData.status !== 'CONVERTED'
      && JSON.parse(localStorage.getItem('roles') || '[]').includes('role_crm_lead_write')
      && JSON.parse(localStorage.getItem('roles') || '[]').includes('role_crm_deal_write');
    return (
      <React.Fragment>
        {/*<Button icon="pi pi-eye" className=" p-button p-mr-2"*/}
        {/*        tooltip={t('view')} tooltipOptions={{ position: 'left' }}*/}
        {/*        onClick={() => {*/}
        {/*          history.push('/crm/lead/read/' + rowData.id)*/}
        {/*        }}/>*/}
        {JSON.parse(localStorage.getItem('roles') || '[]').includes('role_crm_lead_write') &&
          <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                  tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if(entity === 'lead') {
                      history.push('/crm/lead/update/' + rowData.id)
                    } else {
                      history.push('/crm/'+ entity + '/' + action + '/' + id + '?update=lead&leadId=' + rowData.id)
                    }
                  }}/>
        }
        {canConvert && <Button icon="pi pi-arrow-right" className="p-button-success"
                               tooltip={t('crmConvertLead')} tooltipOptions={{position: 'left'}}
                               onClick={() => {
                                 setLoading(true);
                                 axios.get(process.env.REACT_APP_API_HOST + '/api/v2/crm-pipeline?item_per_page=200', {headers: {
                                     'Authorization': 'Bearer ' + localStorage.getItem('userToken'),
                                     'App-Network': localStorage.getItem('networkId')
                                   }})
                                   .then(response => {
                                     const pipelines = (response.data.data.items || []).filter(item => item.active);
                                     const pipeline = pipelines.find(item => item.default) || pipelines[0];
                                     const stage = pipeline?.stages?.find(item => item.active && item.category === 'OPEN');
                                     setConversion({lead: rowData, pipelines, pipelineId: pipeline?.id || null, stageId: stage?.id || null});
                                   })
                                   .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
                                   .finally(() => setLoading(false));
                               }}/>}
        {/*{localStorage.getItem('roles').toString().includes('role_lead_write') &&*/}
        {/*  <>*/}
        {/*    {rowData && rowData.deleted_at_snapshot ? (*/}
        {/*      <Button icon="pi pi-undo" className="p-button-sm p-button-success"*/}
        {/*              tooltip={t('restore')} tooltipOptions={{ position: 'left' }}*/}
        {/*              tooltipOptions={{position: 'left'}}*/}
        {/*              onClick={() => {*/}
        {/*                axios({*/}
        {/*                  method: 'get',*/}
        {/*                  url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "/api/v2/project/" + window.App.state.propsProject.id + "/items/" + rowData.id + "/restore",*/}
        {/*                  params: {},*/}
        {/*                  headers: {*/}
        {/*                    'Authorization': 'Bearer ' + localStorage.getItem("userToken"),*/}
        {/*                    'App-Network': localStorage.getItem("networkId")*/}
        {/*                  }*/}
        {/*                })*/}
        {/*                  .then(response => {*/}
        {/*                    window.App.toastShow('success', t('success_restore'),);*/}
        {/*                    loadLazyData();*/}
        {/*                  })*/}
        {/*                  .catch(error => {*/}
        {/*                    window.App.toastShow('error', t('error'), error.toString(), '', error.response);*/}
        {/*                  })*/}
        {/*              }}*/}
        {/*      />*/}
        {/*    ) : (*/}
        {/*      <Button icon="pi pi-trash" className=" p-button-danger"*/}
        {/*              tooltip={t('delete')} tooltipOptions={{ position: 'left' }}*/}
        {/*              onClick={() => {*/}
        {/*                if (window.confirm('A törlés megerősítésére van szükség!')) {*/}
        {/*                  deleteLead(rowData)*/}
        {/*                }*/}
        {/*              }}*/}
        {/*      />*/}
        {/*    )}*/}
        {/*  </>*/}
        {/*}*/}
      </React.Fragment>
    );
  }

  useEffect(() => {
    loadLazyData();
  }, [lazyParams, scope, window.App.state.rerenderLeadList])

  return (
    <>
      <div className="p-d-flex p-jc-end p-mb-3"><Dropdown value={scope} options={[{value: 'ACTIVE', label: t('crmActiveLeads')}, {value: 'ALL', label: t('crmAllLeads')}]} onChange={event => setScope(event.value)}/></div>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={leads} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
      >
        <Column field="status" header={t('crmLeadStatusLabel')} sortable body={rowData => <Tag value={translateCrmLeadStatus(rowData.status, t)} severity={rowData.status === 'QUALIFIED' || rowData.status === 'CONVERTED' ? 'success' : 'info'}/>}></Column>
        <Column field="name" header={t('columnName')} bodyClassName="col-body-font-bold" sortable body={rowData => rowData.name || rowData.partner?.name || rowData.email || '—'}></Column>
        <Column field="partnerName" header={t('columnPartner')} bodyClassName="col-body-font-bold" sortable filter body={(rowData) => {
          return (
            <a onClick={() => {
              if(action && id) {
                history.push('/crm/'+ entity + '/' + action + '/' + id + '?show=partner&partnerId=' + rowData?.partner?.id)
              } else {
                history.push('/crm/'+ entity + '?show=partner&partnerId=' + rowData?.partner?.id)
              }
            }}>
              {rowData?.partner?.name || '—'}
            </a>
          )
        }}></Column>
        <Column field="campaign.name" header={t('columnCampaign')} sortable></Column>
        <Column field="nextActionAt" header={t('crmNextStep')} sortable body={rowData => rowData.next_action_at ? formatCrmDateTime(rowData.next_action_at, t) : '—'}></Column>
        {/*<Column field="start_date" header={t('columnStart')} sortable className={"p-text-nowrap"} body={(rowData) => {*/}
        {/*  if (rowData.start_date && rowData.start_date !== null) {*/}
        {/*    return (*/}
        {/*      <>{window.App.formatDateValue(rowData.start_date)}</>*/}
        {/*    )*/}
        {/*  }*/}
        {/*}}></Column>*/}
        {/*<Column field="end_date" header={t('columnEnd')} sortable className={"p-text-nowrap"} body={(rowData) => {*/}
        {/*  if (rowData.end_date && rowData.end_date !== null) {*/}
        {/*    return (*/}
        {/*      <>{window.App.formatDateValue(rowData.end_date)}</>*/}
        {/*    )*/}
        {/*  }*/}
        {/*}}></Column>*/}
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
      </DataTable>
      <Dialog visible={Boolean(conversion)} modal style={{width: 'min(620px, 96vw)'}} header={t('crmConvertLead')} onHide={() => setConversion(null)} footer={<Button label={t('crmConvertLead')} icon="pi pi-arrow-right" disabled={!conversion?.pipelineId || !conversion?.stageId} onClick={() => {
        setLoading(true);
        axios.post(process.env.REACT_APP_API_HOST + '/api/v2/crm/workspace/leads/' + conversion.lead.id + '/convert', {name: conversion.lead.name || conversion.lead.partner?.name, pipelineId: conversion.pipelineId, stageId: conversion.stageId}, {headers: {'Authorization': 'Bearer ' + localStorage.getItem('userToken'), 'App-Network': localStorage.getItem('networkId')}})
          .then(response => history.push('/crm/deal/update/' + response.data.data.dealId))
          .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response))
          .finally(() => setLoading(false));
      }}/> }>
        {conversion && <div className="p-fluid p-grid"><div className="p-col-12"><div className="p-field"><label>{t('crmPipeline')}</label><Dropdown value={conversion.pipelineId} options={conversion.pipelines} optionLabel="name" optionValue="id" onChange={event => {const pipeline = conversion.pipelines.find(item => item.id === event.value); const stage = pipeline?.stages?.find(item => item.active && item.category === 'OPEN'); setConversion({...conversion, pipelineId: event.value, stageId: stage?.id || null});}}/></div></div><div className="p-col-12"><div className="p-field"><label>{t('crmOpportunityStage')}</label><Dropdown value={conversion.stageId} options={(conversion.pipelines.find(item => item.id === conversion.pipelineId)?.stages || []).filter(item => item.active)} optionLabel="name" optionValue="id" onChange={event => setConversion({...conversion, stageId: event.value})}/></div></div></div>}
      </Dialog>
    </>
  )
}
export default withTranslation('common')(LeadListComponent);
